"use client";
import { useState } from "react";
const faqs = [
    {
        question: "Is kidney transplant better than dialysis?",
        answer: "Yes. For eligible patients, a kidney transplant generally offers longer survival, improved quality of life, better energy levels, and fewer dietary restrictions compared to long-term dialysis.",
    },
    {
        question: "What is the success rate of renal transplant?",
        answer: "With experienced transplant surgeons, advanced infrastructure, and proper post-operative care, renal transplant success rates are significantly high. Long-term outcomes depend on patient health, donor compatibility, and adherence to medications.",
    },
    {
        question: "How long does recovery take after a kidney transplant?",
        answer: "Most patients stay in the hospital for 1–2 weeks. Full recovery may take a few weeks to a few months, depending on overall health and response to treatment. Regular follow-ups are essential during recovery.",
    },
    {
        question: "Who is eligible for a renal transplant?",
        answer: "You may be eligible if you have end-stage renal disease (ESRD), are medically fit for surgery, have a compatible donor available, and do not have active infections or uncontrolled medical conditions.",
    },
    {
        question: "What types of kidney transplants are available at HDNA Aarogyam Hospital?",
        answer: "We perform:",
        points: [
            "Living Donor Kidney Transplant",
            "Deceased Donor Kidney Transplant",
        ],
        note: "Both procedures follow strict ethical, legal, and medical guidelines."
    },
    {
        question: "How long does the kidney transplant surgery take?",
        answer: "The surgical procedure typically takes around 3–4 hours. However, total hospital time depends on post-operative monitoring and recovery progress.",
    },
    {
        question: "What tests are required before a kidney transplant?",
        answer: "Pre-transplant evaluation includes blood tests, tissue typing, cross-matching, imaging studies, cardiac evaluation, and overall health screening for both donor and recipient.",
    },
    {
        question: "What is the cost of kidney transplant in Patna?",
        answer: "The cost depends on factors such as type of transplant (living or deceased donor), patient condition, hospital stay duration, and post-surgical medications. HDNA Aarogyam Hospital provides transparent cost guidance and insurance assistance.",
    },
    {
        question: "Will I need lifelong medication after a kidney transplant?",
        answer: "Yes. Patients must take immunosuppressive medications for life to prevent organ rejection. Regular follow-up visits and kidney function tests are essential for long-term success.",
    },
    {
        question: "What are the risks associated with kidney transplantation?",
        answer: "Like any major surgery, kidney transplantation carries risks such as infection, bleeding, or organ rejection. However, with advanced ICU care, strict infection control, and expert supervision, risks are significantly minimized.",
    },
]
export default function FaqSection() {
    const [activeIndex, setActiveIndex] = useState(null);
    const leftFaqs = faqs.slice(0, 5);
    const rightFaqs = faqs.slice(5, 10);
    const toggleFaq = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    const renderFaqs = (faqList, offset) =>
        faqList.map((faq, index) => {
            const currentIndex = index + offset;
            return (
                <div key={currentIndex} className="faq-box" onClick={() => toggleFaq(currentIndex)} >
                    {/* Question */}
                    <div className={`faq-question ${activeIndex === currentIndex ? "active" : ""}`}>
                        <h6>{faq.question}</h6>
                        <span className="icon"> {activeIndex === currentIndex ? "−" : "+"}</span>
                    </div>
                    {/* Answer */}
                    {activeIndex === currentIndex && (
                        <div className="faq-answer"> <p>{faq.answer}</p> </div>
                    )}
                </div>
            );
        });

    return (
        <section className="faq-section container">
            <div className="row">
                {/* Left Column */}
                <div className="col-lg-6">{renderFaqs(leftFaqs, 0)}</div>
                {/* Right Column */}
                <div className="col-lg-6">{renderFaqs(rightFaqs, 5)}</div>
            </div>
        </section>
    );
}
